import {
  EnvironmentDomain,
  EnvironmentEnum,
} from 'src/app/models/environment-enum';
import { EnvironmentConfig } from './environment.config';

const backendEnv = EnvironmentDomain.Test;
const backendServerHost = `${backendEnv}-backend-server.fxhedgepool.com`;

export const environment: EnvironmentConfig = {
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  appVersion: require('../../package.json').version,
  production: true,
  name: EnvironmentEnum.Test,
  backendEnv,
  zuul: `https://${backendEnv}-zuul.fxhedgepool.com/`,
  appHost: `https://app-${backendEnv}.fxhedgepool.com`,
  backendServer: `https://${backendServerHost}/`,
  backendServerWSBroker: `wss://${backendServerHost}/ws`,
  reporting: `https://${backendEnv}-reporting.fxhedgepool.com/`,
  loki: `https://${backendEnv}-loki.fxhedgepool.com/`,
  featureFlags: {
    userLayout: true,
  },
};
